import { useEffect, useState } from "react";

export const NAV_OFFSET = 136;

// root: optional scroll container (e.g. the Horse Workspace panel); defaults to the window.
const topOf = (root) => (root ? root.getBoundingClientRect().top : 0);
const atBottom = (root) => (root ? root.scrollTop + root.clientHeight >= root.scrollHeight - 4 : window.innerHeight + window.scrollY >= document.body.scrollHeight - 4);

export function useActiveSection(ids, onChange, root = null, offset = NAV_OFFSET) {
  const [active, setActive] = useState(ids[0]);
  useEffect(() => {
    const target = root || window;
    const onScroll = () => {
      let cur = ids[0];
      ids.forEach((sid) => {
        const el = document.getElementById(sid);
        if (el && el.getBoundingClientRect().top - topOf(root) - offset - 8 <= 0) cur = sid;
      });
      if (atBottom(root)) cur = ids[ids.length - 1];
      setActive((prev) => { if (prev !== cur) onChange?.(cur); return cur; });
    };
    target.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => target.removeEventListener("scroll", onScroll);
  }, [ids, onChange, root, offset]);
  return [active, setActive];
}

export function scrollToEl(el, root = null, offset = NAV_OFFSET) {
  if (!el) return;
  const target = root || window;
  const top = el.getBoundingClientRect().top - topOf(root) + (root ? root.scrollTop : window.scrollY) - offset;
  target.scrollTo({ top, behavior: "smooth" });
}

export function scrollToSection(sid, root = null, offset = NAV_OFFSET) {
  scrollToEl(document.getElementById(sid), root, offset);
}

export function SectionNav({ sections, active, onJump }) {
  return (
    <nav data-testid="ad-section-nav" aria-label="Ad Template sections" className="border-t border-stone-100">
      <div className="max-w-6xl mx-auto px-2 sm:px-8 flex gap-1 overflow-x-auto no-scrollbar py-1.5">
        {sections.map(([sid, label]) => (
          <button key={sid} type="button" data-testid={`nav-${sid}`} aria-current={active === sid ? "true" : undefined}
            onClick={() => onJump(sid)}
            className={`shrink-0 h-8 px-3 rounded-full text-xs sm:text-sm font-semibold transition-colors duration-150 ${active === sid ? "bg-amber-800 text-white" : "text-stone-600 hover:bg-stone-100"}`}>
            {label}
          </button>
        ))}
      </div>
    </nav>
  );
}
